<template>
    <div class="security-page">
        <div v-if="roleChecked">
      <h1>Mod Security Panel</h1>
      <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
  
      
          <!-- Suspicious Activity Alert -->
      <div class="suspicious-activity" v-if="suspiciousIps.length">
        <h2>Suspicious Activity Alert</h2>
        <p>The following IPs have exceeded the failed login threshold in the last hour:</p>
        <ul>
          <li v-for="ip in suspiciousIps" :key="ip.ip_address">
            IP: {{ ip.ip_address }} - Failed Attempts: {{ ip.fail_count }}
          </li>
        </ul>
      </div>
      <!-- Failed Login Summary -->
      <div class="failed-login-summary">
        <h2>Failed Login Summary</h2>
        <p>Total Failed Logins (Last 24h): <strong>{{ failedTotal24h }}</strong></p>
        <h3>Top IPs with Failed Logins</h3>
        <ul>
          <li v-for="ip in topFailedIps" :key="ip.ip_address">
            IP: {{ ip.ip_address }} - Failed Attempts: {{ ip.fail_count }}
          </li>
        </ul>
      </div>
  
      <!-- Login Logs Table -->
      <table v-if="logs.length" class="logs-table">
        <thead>
          <tr>
            <th>Username</th>
            <th>IP Address</th>
            <th>Status</th>
            <th>Login Time</th>
            <th>User Agent</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in logs" :key="log.id">
            <td>{{ log.username }}</td>
            <td>{{ log.ip_address }}</td>
            <td>{{ log.status }}</td>
           <td :class="{ 'late-night': isLateNightLogin(log.login_time) }">
        {{ log.login_time }}
      </td>
            <td>{{ log.user_agent }}</td>
          </tr>
        </tbody>
      </table>
  
      <!-- Pagination Controls -->
      <div v-if="totalPages > 1" class="pagination-controls">
        <button @click="changePage(page - 1)" :disabled="page === 1">Previous</button>
        <span>Page {{ page }} of {{ totalPages }}</span>
        <button @click="changePage(page + 1)" :disabled="page === totalPages">Next</button>
      </div>
      
      <p v-if="!logs.length && !errorMessage">No login attempts to display.</p>
  
      <div class="blacklist-management">
      <h2>Manage Blacklisted IPs</h2>
  

      <!-- List of Blacklisted IPs without Remove Option -->
      <ul v-if="blacklistedIps.length" class="blacklist-list">
          <li v-for="ip in blacklistedIps" :key="ip.id">
              IP: {{ ip.ip_address }}
          </li>
      </ul>
      <p v-else>No IPs are currently blacklisted.</p>
  

  </div>
  
  <!-- Account Lockout Management -->
  <div class="account-lockout">
      <h2>Account Lockout Management</h2>
      <p>Failed Login Attempt Limit: {{ lockoutSettings.maxAttempts }}</p>
      <p>Lockout Duration: {{ lockoutSettings.duration }} minutes</p>
      
      <!-- Manually Unlock Accounts -->
      <ul v-if="lockedAccounts.length" class="locked-accounts">
          <li v-for="account in lockedAccounts" :key="account.username">
              User: {{ account.username }} - Locked Until: {{ account.lockedUntil }}
              <button @click="unlockAccount(account.username)">Unlock</button>
          </li>
      </ul>
      <p v-else>No accounts are currently locked.</p>
  </div>
  
</div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: 'ModSecurityPanel',
  data() {
      return {
          logs: [],
          errorMessage: '',
          page: 1,
          limit: 10,
          total: 0,
          failedTotal24h: 0,
          topFailedIps: [],
          suspiciousIps: [],
          blacklistedIps: [],
          newIpAddress: '',
          showConfirmation: false,
          roleChecked: false,
          lockedAccounts: [], // Stores locked accounts for the lockout management section
            
          lockoutSettings: { // Lockout configuration settings
              maxAttempts: 0,
              duration: 0
          },
      };
  },
    computed: {
      totalPages() {
        return Math.ceil(this.total / this.limit);
      },
        
    },
  mounted() {

    
  this.roleChecked = true;
      this.fetchLogs();
      this.fetchBlacklistedIps();
      this.fetchLockedAccounts();
      this.fetchLockoutSettings(); // Fetch lockout settings on load
  },
  
  methods: {
      validateIp(ip) {
      const ipPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      return ipPattern.test(ip);
  },
  
      fetchLockoutSettings() {
          axios.get('/etherscan/other/lockout_settings.php', {
              headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`
              }
          })
          .then(response => {
              if (response.data.status === 'success') {
                  this.lockoutSettings = response.data.lockout_settings;
              } else {
                  this.errorMessage = response.data.message || 'Failed to fetch lockout settings.';
              }
          })
          .catch(error => {
              console.error('Error fetching lockout settings:', error);
              this.errorMessage = 'An error occurred while fetching lockout settings.';
          });
      },
  
  fetchLockedAccounts() {
      axios.get('/etherscan/other/locked_accounts.php', {
          headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
          }
      })
      .then(response => {
          this.lockedAccounts = response.data.locked_accounts;
      })
      .catch(error => {
          console.error('Error fetching locked accounts:', error);
      });
  },
  unlockAccount(username) {
      axios.post('/etherscan/other/unlock_account.php', { username }, {
          headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
          }
      })
      .then(() => {
          this.fetchLockedAccounts(); // Refresh list after unlock
      })
      .catch(error => {
          console.error('Error unlocking account:', error);
      });
  },

  
      // Fetch Blacklisted IPs
      fetchBlacklistedIps() {
          axios.get('/etherscan/other/fetch.php', {
              headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`
              }
          })
          .then(response => {
              if (response.data.status === 'success') {
                  this.blacklistedIps = response.data.blacklisted_ips;
              } else {
                  this.errorMessage = response.data.message || 'Failed to fetch blacklisted IPs.';
              }
          })
          .catch(error => {
              console.error('Error fetching blacklisted IPs:', error);
              this.errorMessage = 'An error occurred while fetching blacklisted IPs.';
          });
      },
    
  

   
    fetchLogs() {
      axios.get('/etherscan/other/logs.php', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        params: {
          page: this.page,
          limit: this.limit
        }
      })
      .then(response => {
        if (response.data.status === 'success') {
          this.logs = response.data.logs;
          this.total = response.data.total;
          this.failedTotal24h = response.data.failed_total_24h;
          this.topFailedIps = response.data.top_failed_ips;
          this.suspiciousIps = response.data.suspicious_ips; // Store suspicious IPs
        } else {
          this.errorMessage = response.data.message || 'Failed to retrieve logs.';
        }
      })
      .catch(error => {
        console.error('Error fetching logs:', error);
        this.errorMessage = 'An error occurred while fetching the logs. Please try again later.';
      });
    },
    changePage(newPage) {
      this.page = newPage;
      this.fetchLogs();
    },
    isLateNightLogin(loginTime) {
      const date = new Date(loginTime);
      const hours = date.getHours();
      return hours >= 23 || hours < 5; // Returns true if between 11 PM and 5 AM
    }
  }
  
  };
  </script>
  
  <style scoped>
  .security-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .logs-table {
    margin-top: 20px;
    width: 100%;
    border-collapse: collapse;
  }
  
  .logs-table th, .logs-table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }
  
  .pagination-controls {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }
  
  .pagination-controls button {
    margin: 0 10px;
  }
  
  .error-message {
    color: red;
    margin-top: 10px;
  }
  .late-night {
    background-color: #ffdd57; /* Soft yellow background for highlighting */
    font-weight: bold;
    color: #b85c00;
  }
  .failed-login-summary {
    margin-bottom: 20px;
    text-align: left;
  }
  
  .failed-login-summary h2, .failed-login-summary h3 {
    color: #333;
  }
  
  .failed-login-summary ul {
    list-style-type: none;
    padding: 0;
  }
  
  .failed-login-summary ul li {
    font-weight: bold;
  }
  .suspicious-activity {
    background-color: #ffdddd;
    border: 1px solid #ff5555;
    padding: 15px;
    margin-bottom: 20px;
  }
  
  .suspicious-activity h2 {
    color: #a80000;
  }
  
  .suspicious-activity ul {
    list-style-type: none;
    padding: 0;
  }
  
  .suspicious-activity ul li {
    font-weight: bold;
  }
  .blacklist-management {
      margin-top: 20px;
      text-align: left;
  }
  
  .add-ip-form {
      margin-bottom: 10px;
  }
  
  .add-ip-form input {
      padding: 5px;
      margin-right: 5px;
  }
  
  .blacklist-list {
      list-style-type: none;
      padding: 0;
  }
  
  .blacklist-list li {
      margin-bottom: 5px;
  }
  
  .confirmation-dialog {
      background-color: #ffdddd;
      border: 1px solid #ff5555;
      padding: 15px;
      margin-top: 15px;
      text-align: center;
  }
  
  </style>
  